<template>
    <!--门店收益-->
    <div class="page-wrap">
        <div class="page-body">
            <div class="search-box">
                <ChainStoreSelect v-model="form.search_store_id" />&nbsp;
                <el-date-picker
                        v-model="form.start_date"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                </el-date-picker>&nbsp;&nbsp;
                <el-date-picker
                        v-model="form.end_date"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                </el-date-picker>&nbsp;&nbsp;
                <el-button type="primary" @click="loadListData">搜索</el-button>&nbsp;&nbsp;
                <el-button-group>
                    <el-button @click="setFormDate(1)">本月</el-button>
                    <el-button @click="setFormDate(2)">上月</el-button>
                </el-button-group>
            </div>

            <div class="summary-body">
                <div class="select-box">
                    <el-select v-model="form.type" placeholder="请选择">
                        <el-option label="总收益" value="" />
                        <el-option
                                v-for="item in typeList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                    &nbsp;
                    <el-tooltip class="item" effect="dark" content="所有收益为：办理会员、会员充值、会员续费、消费项目、购买卡项、购买产品之和且不包含余额支付" placement="top-start">
                        <i class="el-icon-info"></i>
                    </el-tooltip>
                </div>
                <div class="chart-box">
                    <div class="chart-dom">
                        <ECharts :options="chartOption" ref="ECharts" :autoresize="true" />
                    </div>
                    <div class="table-box">
                        <el-table
                                :data="incomeData"
                                show-summary
                                :summary-method="totalEvent"
                                style="width: 100%">
                            <el-table-column
                                    prop="total_date"
                                    label="时间"
                                    sortable>
                            </el-table-column>
                            <el-table-column
                                    prop="store_name"
                                    label="门店">
                            </el-table-column>
                            <el-table-column label="收益类型">
                                <template slot-scope="data">
                                    {{data.row.type_name}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="money" label="金额" sortable>
                                <template slot-scope="data">
                                    ¥{{data.row.money}}
                                </template>
                            </el-table-column>
                            <el-table-column prop="actual_money" label="实收金额" v-if="!nowType">
                                <template slot-scope="data">
                                    ¥{{data.row.actual_money}}
                                </template>
                            </el-table-column>
                            <el-table-column
                                    label="操作">
                                <template slot-scope="data">
                                    <el-button type="text" @click="showInfo(data.row)">详情</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>

        <!--明细-->
        <ChainSummaryStoreData v-model="storeDataShow" :item="dataItem" />
    </div>
</template>

<script>
    import obj from "@/js/obj";
    import ECharts from 'vue-echarts';
    import 'echarts/lib/chart/line';
    import 'echarts/lib/component/polar';
    import 'echarts/lib/component/tooltip';
    import 'echarts/lib/component/legend';
    import ChainStoreSelect from "@/model/Chain/ChainStoreSelect";
    import ChainSummaryStoreData from "@/model/Chain/ChainSummaryStoreData";

    export default {
        name: "ChainSummaryStore",
        components: {ChainSummaryStoreData, ChainStoreSelect, ECharts},
        data: () => {
            let startDate = new Date();
            startDate.setTime(startDate.getTime() - 1000 * 3600 * 24 * 7);

            let endDate = new Date();
            endDate.setTime(endDate.getTime());

            let data = [];

            for (let i = 0; i <= 360; i++) {
                let t = i / 180 * Math.PI;
                let r = Math.sin(2 * t) * Math.cos(2 * t);
                data.push([r, i])
            }

            return {
                form: {
                    search_store_id: "",
                    start_date: startDate.getFullYear() + "-" + (startDate.getMonth()+1) + "-" + startDate.getDate(),
                    end_date: endDate.getFullYear() + "-" + (endDate.getMonth()+1) + "-" + endDate.getDate(),
                    type: ""
                },
                typeList: [
                    {
                        label: "办理会员",
                        value: "6"
                    }, {
                        label: "会员充值",
                        value: "3"
                    }, {
                        label: "会员续费",
                        value: "4"
                    }, {
                        label: "消费项目",
                        value: "1"
                    }, {
                        label: "购买卡项",
                        value: "5"
                    }, {
                        label: "购买产品",
                        value: "2"
                    }
                ],
                nowType: "",
                incomeData: [],         //收入数据

                //图表配置
                chartOption: {},
                storeDataShow: false,
                dataItem: {},

                //加载层
                loading: false,
                loadDom: null,
            };
        },
        mounted: function () {
            this.loadListData();
        },
        methods: {
            //设置配置
            setOption: function () {
                //解析数据
                let dateArr = [];
                let nameArr = [];
                let seriesArr = [];
                this.incomeData.forEach( val => {
                    dateArr.push(val.total_date);
                    if(!obj.inArray(val.type_name, nameArr)) {
                        nameArr.push(val.type_name);
                        seriesArr.push({
                            name: val.type_name,
                            type: "line",
                            smooth: true,
                            data: [val.money]
                        });
                    }else{
                        for (let i = 0; i < seriesArr.length; i++) {
                            if(seriesArr[i].name === val.type_name) {
                                seriesArr[i].data.push(val.money);
                            }
                        }
                    }
                });

                this.chartOption = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data:nameArr,
                        bottom: 0
                    },
                    xAxis: {
                        type: 'category',
                        data: dateArr
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: seriesArr,
                    animationDuration: 1000
                };

            },
            //获取数据
            loadListData: function () {
                let postData = this.form;
                this.loading = true;
                obj.postData("chain_summary/get_store_income_data", postData, res => {
                    if(res.errcode === 0) {
                        this.nowType = this.form.type;
                        this.incomeData = res.data;
                        this.setOption();
                    }else{
                        obj.message.error(res.errdesc);
                    }
                    this.loading = false;
                });
            },
            //修改日期
            setFormDate: function (d) {
                let date = new Date();
                if(d === 1) {
                    date.setDate(1);
                    this.form.start_date = date.getFullYear()+"-"+(date.getMonth()+1)+"-"+date.getDate();
                    let lastDate = new Date();
                    this.form.end_date = lastDate.getFullYear()+"-"+(date.getMonth()+1)+"-"+lastDate.getDate();
                }else if(d === 2){
                    date.setDate(1);
                    this.form.start_date = date.getFullYear()+"-"+date.getMonth()+"-"+date.getDate();
                    date.setMonth(date.getMonth() + 1);
                    let lastDate = new Date(date.getTime() - 1000 * 3600 * 24);
                    this.form.end_date = lastDate.getFullYear()+"-"+lastDate.getMonth()+"-"+lastDate.getDate();
                }
                this.loadListData();
            },
            //显示明细
            showInfo: function (data) {
                this.dataItem = data;
                this.storeDataShow = true;
            },
            //统计计算
            totalEvent: function (params) {
                let {columns, data} = params;
                let sumMoney = 0;
                let sumActual = 0;
                data.forEach(val => {
                   sumMoney += parseFloat(val.money);
                   sumActual += parseFloat(val.actual_money);
                });

                let result = [];
                if(this.nowType) {
                    result = ["合计", "", "", "¥" + sumMoney.toFixed(2)];
                }else{
                    result = ["合计", "", "", "¥" + sumMoney.toFixed(2), "¥" + sumActual.toFixed(2) ];
                }
                return result;
            }
        },
        watch: {
            loading: function (val) {
                if(val){
                    this.loadDom = this.$loading({
                        lock: false,
                        // text: 'Loading',
                        // spinner: 'el-icon-loading',
                        background: 'rgba(255, 255, 255, 0.3)',
                        target: ".container"
                    });
                }else{
                    this.loadDom.close();
                }
            },
            "form.type": function (val) {
                this.loadListData();
            }
        }
    }
</script>

<style scoped>
    .search-box{
        padding: 16px 0;
        background-color: #ffffff;
    }
    .summary-body{
        padding: 16px 0;
        background-color: #ffffff;
    }
    .table-box{
        margin-top: 60px;
        padding: 16px;
    }
    .el-icon-info{
        color: #cccccc;
        font-size: 17px;
    }
    .echarts {
        width: 100%;
        height: 360px;
    }
</style>

